import type { FormikHelpers } from 'formik';
import * as apiTariff from 'api/apiTariff';
import type { TariffApplicationFormValues } from './types';

type TranslateFn = (key: string, options?: Record<string, string>) => string;
type ShowToastFn = (message: string, type: 'success' | 'danger') => void;

export interface SubmitApplicationParams {
    t: TranslateFn;
    showToast: ShowToastFn;
    onHide: () => void;
}

export const submitApplication = async (
    values: TariffApplicationFormValues,
    _helpers: FormikHelpers<TariffApplicationFormValues>,
    params: SubmitApplicationParams,
): Promise<void> => {
    const { t, showToast, onHide } = params;

    const res = await apiTariff.sendTariffApplication({
        planId: String(values.planId || '').trim(),
        planKey: String(values.planKey || '').trim(),
        accountUuid: String(values.accountUuid || '').trim(),
        companyName: String(values.companyName || '').trim(),
        taxId: String(values.taxId || '').trim(),
        phone: String(values.phone || '').trim(),
        email: String(values.email || '').trim(),
        legalAddress: String(values.legalAddress || '').trim(),
        representativeName: String(values.representativeName || '').trim(),
    });

    if (res?.stat) {
        onHide();
        showToast(t('application.messApplicationSent'), 'success');
        return;
    }

    showToast(t('common:messError'), 'danger');
};
